import styled from "styled-components";

export const PaddedWrapper = styled.div`
  && {
    padding: ${props => props.padding || "0 1em"};
  }
`;

export const PaddedWrapperFullWidth = styled.div`
  padding: ${props => props.padding || "1.5em 1em"};
  width: 100%;
`;

export const ColumnWrapper = styled.div`
  && {
    display: flex;
    flex-direction: row;
    justify-content: ${props => props.justifyContent || "flex-start"};
  }
`;

export const StyledInfo = styled.div`
  font-family: Work Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
`;

export const Title = styled.div`
  font-family: Work Sans;
  font-size: ${props => props.fontSize || "24px"};
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0em;
  padding-top: ${props => props.paddingTop || 0};
  text-align: left;
`;

export const Row = styled.div`
  && {
    align-items: center;
    border-bottom: ${props => props.borderBottom || "1px solid #dadce0"};
    box-sizing: border-box;
    display: flex;
    min-height: 88px;
    justify-content: ${props => props.justifyContent || "space-between"};
    width: 100%;
  }
`;

export const Header = styled.div`
  && {
    align-items: center;
    background: #ffffff;
    border: ${props => !props.isLineItem && "1px solid #dadce0"};
    box-shadow: ${props => !props.isLineItem && "0px 10px 20px rgba(173, 174, 174, 0.25)"};
    box-sizing: border-box;
    display: flex;
    height: 88px;
    justify-content: space-between;
    margin-bottom: ${props => !props.isLineItem && "1em"};
    width: 100%;
    z-index: 2;
  }
`;
